import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service/';
import messages from './messages';

export const AMOUNTS = 'amounts';

export default {
  id: AMOUNTS,
  displayName: () => <FormattedMessage {...messages.amount} />,
  type: OptionFormTypes.TYPE_CURRENCY_COMPARISON,
  filterValue: 'amounts',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CURRENCY_COMPARISON, criteriaInformations);
  },
};
